import Pricelist from './Pricelist'

export default Pricelist



// WEBPACK FOOTER //
// ./src/components/Pricelist/index.js